import React from 'react';
import { Label, Box } from 'fw/components';
import { Form, TextAreaBox } from 'fw/forms';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';
import { FlagStatusCombo } from 'areas/shared/controls';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';

class FlagCasePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,

            saving: false,
            loadingFlagData: false,
            clearFlagMode: false,

            buttons: {
                saveFlag: { disabled: false },
                clearFlag: { disabled: true }
            },

            form: {
                flagStatusCode: null,
                flagComments: null,
                clearFlagComments: null
            },

            entityId: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            saving: false,
            form: nextProps.currentFlagStatus
        });
    }

    urls() {
        return {
            addFlag: APIRoutes.Admin.url("/appReview/addFlag"),
            clearFlag: APIRoutes.Admin.url("/appReview/clearFlag"),
            getFlag: APIRoutes.Admin.url("/appReview/getFlag")
        }
    }

    saveFlagReviewRequest() {
        return {
            entityId: this.state.form.entityId,
            certificationKey: this.props.certificationKey,
            flagCode: this.state.form.flagStatusCode,
            flagComments: this.state.form.flagComments,
            queueTypeCode: this.props.queueTypeCode,
            reviewTypeCode: this.props.reviewTypeCode
        };
    }

    getFlagReviewRequest(flagStatusCode) {
        return {
            certificationKey: this.props.certificationKey,
            flagCode: flagStatusCode
        };
    }

    clearFlagReviewRequest(flagStatusCode) {
        return {
            entityId: this.state.form.entityId,
            certificationKey: this.props.certificationKey,
            flagCode: this.state.form.flagStatusCode,
            flagClearComments: this.state.form.clearFlagComments,
            queueTypeCode: this.props.queueTypeCode,
            reviewTypeCode: this.props.reviewTypeCode
        };
    }

    saveFlag = () => {
        if (!this._form.validate())
            return;

        const me = this;
        let url = this.urls().addFlag;
        let rq = {};

        rq = this.saveFlagReviewRequest();

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    me.setState({
                        saving: false,
                        rowVersion: r.data.rowVersion,
                        form: {
                            ...me.state.form,
                            ...r.data,
                            original: {
                                ...me.state.form,
                                ...r.data
                            }
                        }
                    }, () => {
                        Notifications.success("The Flag has been added.");
                        if (me.props.onSave)
                            me.props.onSave(me.state.form, r.data);
                        me.close();
                    });
                },
                error: r => {
                    me.setState({ saving: false });
                    Notifications.error(r.error.errorMessage);
                    if (me.props.onError)
                        me.props.onError(r.error);
                }
            })
        });
    }

    clearFlag = () => {
        if (!this._form.validate())
            return;

        const me = this;
        let url = this.urls().clearFlag;
        let rq = {};

        rq = this.clearFlagReviewRequest();

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    me.setState({
                        saving: false,
                        rowVersion: r.data.rowVersion,
                        clearFlagMode: false,
                        form: {}
                    }, () => {
                        Notifications.success("The Flag has been removed.");
                        if (me.props.onSave)
                            me.props.onSave(me.state.form, r.data);
                        me.close();
                    });
                },
                error: r => {
                    me.setState({ saving: false });
                    Notifications.error(r.error.errorMessage);
                    if (this.props.onError)
                        this.props.onError(r.error);
                }
            })
        });
    }

    close = () => {
        this.setState(this.initialState(this.props), function () {
            this.props.onClose();
        });
    }

    onChangeDropdown = (value) => {
        let flagStatusCode = value.value;

        let url = this.urls().getFlag;
        let rq = {};

        rq = this.getFlagReviewRequest(flagStatusCode);

        this.setState({
            loadingFlagData: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    this.setState({
                        loadingFlagData: false,
                        clearFlagMode: true,
                        rowVersion: r.data.rowVersion,
                        form: {
                            ...this.state.form,
                            ...r.data,
                            original: {
                                ...this.state.form,
                                ...r.data
                            }
                        }
                    });
                },
                error: (r) => {
                    this.setState({
                        loadingFlagData: false,
                        clearFlagMode: false,
                        form: {
                            ...this.state.form,
                            flagComments: null,
                            clearFlagComments: null
                        }
                    });
                }
            })
        });

    };

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    renderFlagCommentsSection() {
        let me = this;
        let title = (
            <Row>
                <Col md={12}>
                    <Label htmlFor="flagComments" required>Flag Comment(s)</Label>&nbsp;Please remember that a comment will be required when a Flag is applied to an Application
                </Col>
            </Row>
        );
        if (this.state.clearFlagMode && me.state.form != null) {
            return (
                <React.Fragment>
                    {title}
                    <Box>
                        <span dangerouslySetInnerHTML={{ __html: me.state.form.flagComments }} />
                    </Box>
                </React.Fragment>
            )
        }
        else {
            return (
                <React.Fragment>
                    {title}
                    <Row>
                        <Col md={12}>
                            <TextAreaBox name="flagComments" maxLength={200} rows={4} required />
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
    }

    renderClearFlagSection() {
        if (this.state.clearFlagMode) {
            return (
                <React.Fragment>
                    <Row>
                        <Col md={12}>
                            <Label htmlFor="clearFlagComments" required>Clear Flag Comment(s)</Label>&nbsp;A comment will be required to clear a Flag from an Application
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TextAreaBox name="clearFlagComments" maxLength={2500} rows={4} required />
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
        else {
            return (<React.Fragment></React.Fragment>)
        }
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Flag Case&nbsp;<small>Please select a Flag to assign to the Application</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.handleChange}
                        values={this.state.form}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label htmlFor="flagStatusCode" required>Flag Status</Label>
                                    <FlagStatusCombo name="flagStatusCode"
                                        onChange={this.onChangeDropdown}
                                        required />
                                </FormGroup>
                            </Col>
                        </Row>
                        {this.renderFlagCommentsSection()}
                        {this.renderClearFlagSection()}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" disabled={!this.state.clearFlagMode || this.state.saving} onClick={this.clearFlag}>Clear Flag</Button>
                    <Button bsStyle="success" disabled={this.state.clearFlagMode || this.state.saving} onClick={this.saveFlag}>Save</Button>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default FlagCasePopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/FlagCasePopUp.js